<ng-content select="[layoutSubHeader]" />

<div class="accredible-content">
  <div class="accredible-content-main">
    <ng-content select="[layoutContent]" />
  </div>

  <!-- Desktop articles -->
  @if (isDesktop) {
    <aside class="accredible-articles">
      <ng-content select="[layoutSideContent]" />
    </aside>
  }
</div>
